<template>
  <div>
    <div class="das_top_cont bill_record">
      <div class="history_box account_input">
        <div class="das_top_cont bill_record_top_cont">
          <ul class="das_top_list flex_center_between_box phoen_center_flex_warp">
            <li class="das_top_item">
              <div class="item_img color1 flex_center">
                <svg t="1723082123845" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5676" width="60px" height="60px">
                  <path
                    d="M875.881412 0A118.061176 118.061176 0 0 1 993.882353 118.151529v98.484706h-98.334118v689.212236A118.061176 118.061176 0 0 1 777.517176 1024H148.118588A118.061176 118.061176 0 0 1 30.117647 905.848471v-98.484706h78.667294V118.181647A118.061176 118.061176 0 0 1 226.816 0h649.035294z m-19.666824 39.393882H226.785882a78.727529 78.727529 0 0 0-78.697411 78.757647v689.242353a19.666824 19.666824 0 0 1 0 39.363765H69.451294v59.090824a78.727529 78.727529 0 0 0 78.667294 78.757647H738.183529v-137.848471H384.150588a19.666824 19.666824 0 0 1 0-39.363765h393.366588v177.212236a78.727529 78.727529 0 0 0 78.697412-78.757647V39.363765z m-550.731294 768a19.666824 19.666824 0 0 1 0 39.363765H266.149647a19.666824 19.666824 0 0 1 0-39.363765z m413.033412-137.84847a19.666824 19.666824 0 0 1 0 39.363764H285.816471a19.666824 19.666824 0 0 1 0-39.363764z m-98.334118-118.15153a19.666824 19.666824 0 0 1 0 39.363765h-236.032a19.666824 19.666824 0 0 1 0-39.363765h236.032z m-112.037647-452.126117c11.565176 0 20.961882 9.396706 20.961883 20.961882v18.552471c57.825882 6.264471 93.485176 39.996235 95.412705 97.822117h-44.333176c-2.409412-34.695529-21.684706-53.007059-51.079529-58.789647v105.050353c69.872941 14.938353 105.050353 44.333176 105.050352 97.340235 0 58.307765-49.152 87.702588-105.050352 92.521412v18.552471a20.961882 20.961882 0 0 1-41.923765 0v-19.034353c-57.825882-6.264471-98.785882-38.068706-103.604706-99.267765h44.333176c3.373176 34.213647 24.094118 54.452706 59.27153 60.717177v-114.206118c-63.126588-13.974588-94.930824-39.514353-94.930824-90.112 0-51.079529 39.996235-83.847529 94.930824-90.112v-19.034353c0-11.565176 9.396706-20.961882 20.961882-20.961882z m20.961883 226.002823v109.387294c34.213647-3.855059 59.271529-20.239059 59.271529-50.597647 0-30.840471-20.239059-49.152-59.271529-58.789647z m-41.923765-147.937882c-30.358588 5.300706-49.152 22.166588-49.152 49.152 0 28.431059 16.865882 42.887529 49.152 51.561412z m408.365176-129.505882v129.415529h59.000471V118.151529c0-30.780235-27.527529-57.374118-59.030588-70.354823z"
                    fill="#1290C9" p-id="5677"></path>
                </svg>
              </div>
              <div class="item_group">
                <label class="item_lab">{{ $t('BillingandPayment.TotalNumberofOrders') }}</label>
                <div class="item_txt item_txtcolor1">{{ totalBillingExpenses }}</div>
              </div>
            </li>
            <li class="das_top_item das_top_itempadding">
              <div class="item_img color2 flex_center">
                <svg t="1723082165954" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5925" width="60px" height="60px">
                  <path
                    d="M226.43 321.98l-25.25-16.2 99.19-154.67c15.09-23.52 38.52-39.79 65.99-45.79 27.47-6 55.55-1 79.08 14.08l65.11 41.75-16.2 25.25-65.11-41.75c-16.78-10.76-36.84-14.33-56.48-10.03-19.64 4.29-36.38 15.9-47.14 32.68l-99.19 154.68z"
                    fill="#55B419" p-id="5926"></path>
                  <path
                    d="M276.85 325.03l-15-25.98 308.51-178.12c24.2-13.97 52.49-17.66 79.65-10.38 27.16 7.28 49.81 24.61 63.78 48.82l84.89 147.03-25.98 15-84.89-147.03c-20.68-35.81-66.64-48.13-102.45-27.45L276.85 325.03zM923.78 734.95H653.75c-35.84 0-65-29.16-65-65V562c0-35.84 29.16-65 65-65h292.66v215.32c0.01 12.48-10.15 22.63-22.63 22.63zM653.75 527c-19.3 0-35 15.7-35 35v107.95c0 19.3 15.7 35 35 35h262.66V527H653.75z"
                    fill="#55B419" p-id="5927"></path>
                  <path
                    d="M841.42 939.61H213.64c-57.9 0-105-47.1-105-105V397.34c0-57.9 47.1-105 105-105h627.78c57.9 0 105 47.1 105 105V834.6c0 57.91-47.11 105.01-105 105.01zM213.64 322.34c-41.36 0-75 33.64-75 75V834.6c0 41.36 33.64 75 75 75h627.78c41.36 0 75-33.64 75-75V397.34c0-41.36-33.64-75-75-75H213.64z"
                    fill="#55B419" p-id="5928"></path>
                  <path d="M731.07 615.98m-39.33 0a39.33 39.33 0 1 0 78.66 0 39.33 39.33 0 1 0-78.66 0Z" fill="#55B419"
                    p-id="5929"></path>
                </svg>
              </div>

              <div class="item_group">
                <label class="item_lab">{{ $t('BillingandPayment.TotalPaymentAmount') }}</label>
                <div class="item_txt item_txtcolor2">{{ totalPaymentAmount }}</div>
              </div>
            </li>
            <li class="das_top_item">
              <div class="item_img color3 flex_center">
                <svg t="1723082225205" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="6181" width="60px" height="60px">
                  <path
                    d="M723.592631 31.919543a25.073371 25.073371 0 0 1 4.183771 2.6624c52.048457 41.077029 77.326629 98.538057 69.339429 157.696-7.3728 54.710857-41.632914 103.2192-93.622857 134.436571 5.295543 3.6864 11.117714 7.606857 16.676571 11.322515 75.483429 50.731886 232.535771 156.320914 258.984229 340.816457a23.698286 23.698286 0 0 1 0.2048 2.633143c3.072 90.989714 9.508571 280.312686-236.778057 338.651428a23.581257 23.581257 0 0 1-4.242286 0.585143c-44.2368 2.4576-105.150171 3.2768-166.648686 3.2768-115.858286 0-233.8816-2.8672-246.637714-3.218286h-0.760686c-5.266286 0.292571-176.3328 9.362286-238.006857-107.783314-66.091886-85.869714-52.545829-329.728 24.956343-438.272a497.751771 497.751771 0 0 1 154.799543-140.288c-16.1792-28.379429-39.3216-79.169829-38.0928-136.338286 1.930971-91.077486 76.887771-161.967543 142.979657-168.638171a24.283429 24.283429 0 0 1 24.576 33.9968 24.254171 24.254171 0 0 1-19.719314 14.160457c-45.787429 4.593371-98.011429 57.5488-99.386515 121.504914-0.936229 43.446857 16.296229 83.324343 29.374172 107.168915l338.154057-0.029258a27.794286 27.794286 0 0 1 3.159771-3.803428 24.020114 24.020114 0 0 1 7.694629-5.149257c52.604343-22.3232 87.888457-63.985371 94.295771-111.469715 5.617371-41.691429-11.936914-81.3056-49.444571-111.762285-59.977143-29.344914-112.522971-33.411657-156.145372-12.0832-92.511086 45.290057-121.768229 188.269714-122.0608 189.703314a24.254171 24.254171 0 0 1-47.601371-9.362286c1.404343-6.846171 34.464914-168.053029 148.333714-223.787885 58.514286-28.613486 126.303086-24.107886 201.435429 13.370514z m-190.2592 322.706286l-211.1488 0.029257a24.312686 24.312686 0 0 1-11.790629 11.205485 107.081143 107.081143 0 0 0-2.837943 1.345829l-3.218285 1.609143c-21.416229 10.8544-95.290514 52.370286-153.629257 133.997714-69.105371 96.782629-75.073829 320.1024-25.102629 381.922743a23.1424 23.1424 0 0 1 2.720914 4.242286c39.233829 77.151086 151.171657 83.470629 185.197715 83.646171h4.593371l5.032229-0.117028h0.292571c2.925714 0 104.769829 2.516114 213.372343 3.013485l18.666057 0.058515c65.418971 0.175543 131.364571-0.497371 177.9712-2.954972 188.884114-45.641143 201.289143-172.470857 197.485714-288.182857-23.9616-162.464914-163.079314-256-237.889828-306.322286-14.248229-9.567086-25.248914-16.969143-33.528686-23.493485h-29.461943c28.028343 35.4304 63.107657 101.727086 68.169143 214.747428 7.460571 4.096 12.4928 12.024686 12.4928 21.123657a24.195657 24.195657 0 1 1-36.805486-20.6848c-5.792914-126.303086-51.551086-189.761829-76.419657-215.186285h-37.741714c18.753829 43.446857 48.888686 124.489143 37.858743 174.109257a23.873829 23.873829 0 0 1 7.226514 17.173943 24.195657 24.195657 0 1 1-30.749257-23.288686l-1.111772 4.564114c12.463543-41.662171-18.958629-126.390857-39.643428-172.558628z m-186.543543 141.604571c12.551314 0 22.703543 10.181486 22.703543 22.7328v19.982629c62.6688 6.787657 101.288229 43.242057 103.394743 105.735314h-48.040229c-2.633143-37.507657-23.493486-57.285486-55.354514-63.546514v113.517714c75.717486 16.1792 113.810286 47.952457 113.810286 105.237943 0 63.019886-53.248 94.793143-113.810286 99.971657v20.011886a22.703543 22.703543 0 0 1-45.407086 0v-20.509258c-62.639543-6.787657-107.022629-41.1648-112.259657-107.285942H259.866917c3.657143 36.951771 26.097371 58.836114 64.219428 65.623771v-123.465143c-68.4032-15.096686-102.838857-42.686171-102.838857-97.367771 0-55.208229 43.300571-90.609371 102.838857-97.397029v-20.509257c0-12.551314 10.152229-22.703543 22.703543-22.703543z m22.703543 244.297143v118.198857c37.0688-4.154514 64.219429-21.855086 64.219428-54.6816 0-33.353143-21.942857-53.130971-64.219428-63.546514z m-45.407086-159.919543c-32.885029 5.7344-53.248 23.990857-53.248 53.130971 0 30.72 18.256457 46.343314 53.248 55.734858z"
                    fill="#FFA000" p-id="6182"></path>
                </svg>
              </div>
              <div class="item_group">
                <label class="item_lab">{{ $t('BillingandPayment.TotalDeductionCredits') }}</label>
                <div class="item_txt item_txtcolor3">{{ totalDeductionPoints }}</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="accountright_cont_box">
          <h2 class="history_box-head flex_center_between_box"> {{ $t('AccountCenterMenu.BillRecords') }}</h2>
          <div class="flex_center_between_box">
            <div style="display: flex">
              <div class="sel_box computer_right_cont_box br_filter_first">
                <el-date-picker v-model="datePicker" type="daterange" range-separator=""
                  :start-placeholder="$t('BillingandPayment.StartingMonth')" value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  :end-placeholder="$t('BillingandPayment.EndMonth')"></el-date-picker>
              </div>
              <div class="sel_box computer_right_cont_box br_filter_second">
                <el-input class="inline-input" :suffix-icon="CategoryVal ? '' : 'el-icon-search'" clearable
                  v-model="CategoryVal" :placeholder="$t('BillingandPayment.UserAccount')"></el-input>
                <!-- suffix-icon="el-icon-search" -->
              </div>
              <!-- <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" clearable v-model="CategoryVal1" placeholder="Payment Points"></el-input>
              </div> -->
            </div>
            <button class="btn_blue flex_center search_btn br_filter_button"
              @click="page.pageNo = 1; getgetUserActionLogPage()">
              <!-- <img src="../../assets/img/detail/btn_ic5.png" /> -->
              {{ $t('Home.search') }}
            </button>
          </div>
          <div class="his_sel_box" style="width: 100%" empty-text="No Data">
            <el-table class="spec_table br_table" :data="yourUsagelist" style="width: 100%">
              <el-table-column prop="createTime" :label="$t('MyDatabase.Date')" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="email" :label="$t('BillingandPayment.UserAccount')" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.email }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="productName" :label="$t('Ownership.Type')" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class=" company_link">
                    {{ scope.row.productName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="rechargesNo" :label="$t('BillingandPayment.OrderNo')" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">
                    {{ scope.row.rechargesNo }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column prop="paymentMethod" :label="$t('BillingandPayment.OrderType')" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content" v-if="scope.row.paymentMethod == 1">Credit card</span>
                  <span class="table-content" v-if="scope.row.paymentMethod == 2">PayPal payment</span>
                  <span class="table-content" v-if="scope.row.paymentMethod == 3">Bank card transfer</span>
                  <span class="table-content" v-if="scope.row.paymentMethod == 4">Backend ERP recharge</span>
                  <span class="table-content" v-if="scope.row.paymentMethod == 5">Other channels</span>
                </template>
              </el-table-column>

              <el-table-column prop="Status" :label="$t('BillingandPayment.OrderStatus')" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content" v-if="scope.row.status == 1">Pending payment</span>
                  <span class="table-content" v-if="scope.row.status == 2">Finished</span>
                  <span class="table-content" v-if="scope.row.status == 3">Payment failed</span>
                  <span class="table-content" v-if="scope.row.status == 4">Cancel payment</span>
                </template>
              </el-table-column>
              <el-table-column prop="" :label="$t('MyDatabase.Download')" align="center" width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content flex_center" @click="Down(scope.row)">
                    <svg v-if="scope.row.status == 2" t="1723022129119" class="icon" viewBox="0 0 1024 1024"
                      version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6324" width="2rem" height="2rem">
                      <path
                        d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                        fill="#1296db" p-id="6325"></path>
                    </svg>
                    <svg t="1725877594421" class="icon" v-else viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="5401" width="28" height="28">
                      <path
                        d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                        fill="#999999" p-id="5402"></path>
                    </svg>
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <div class="page_i_box" v-if="yourUsagelist.length > 0">
              <Page :totalFont="true" :total="page.total" :pageSize.sync="page.pageSize" :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"></Page>

              <div class="search_rsult_txt line_2">{{ page.pageNo }}-{{ page.pageSize }} of over {{ page.total |
                FilterNum }}
                results for "{{ $t('AccountCenterMenu.BillRecords') }}"</div>
            </div>
            <!-- <div v-show="this.page.total>this.page.pageSize" style="text-align: center; padding-top: 20px" class="show_AllHeight">
              <span class="contclass show_All" @click="apptablelist">Show More</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import { getUserRechargesPage, getbillingAndPaymentStatistics, getUserRechargesPdfAddress } from "@/api/userApi";
import ReLogin from "../../../components/ReLogin.vue";
import Page from '@/components/page/index.vue';
export default {
  mixins: [mixins1],
  components: {
    ReLogin,
    Page
  },
  data() {
    return {
      reLoginVis: false,
      datePicker: [],
      CategoryVal: "",
      CategoryVal1: '',
      IndicatorsValType: "",
      type: [],
      IndicatorsValStatus: "",
      yourUsagelist: [],
      totalPaymentAmount: '',
      totalDeductionPoints: '',
      totalBillingExpenses: '',

      window: window,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
    };
  },
  beforeDestroy() { },
  destroyed() { },
  mounted() {
    this.getgetUserActionLogPage();
  },

  methods: {
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page
      this.getgetUserActionLogPage();
    },

    getgetUserActionLogPage() {
      getUserRechargesPage({
        email: this.CategoryVal,
        actualAmount: this.CategoryVal1,
        startTime: this.datePicker == null ? "" : this.datePicker[0],
        endTime: this.datePicker == null ? "" : this.datePicker[1],
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          this.yourUsagelist = res.data.rows;
          this.page.total = res.data.total
        } else {
          this.yourUsagelist = [];
        }
      }).catch(err => {
        this.reLoginVis = String(err).includes('403')
      });
      getbillingAndPaymentStatistics().then(res => {
        if (res.code == 200) {
          this.totalBillingExpenses = res.data.totalBillingExpenses
          this.totalDeductionPoints = res.data.totalDeductionPoints
          this.totalPaymentAmount = res.data.totalPaymentAmount
        }

      })
    },

    apptablelist() {

      this.page.pageSize = this.page.pageSize + 5
      this.getgetUserActionLogPage()
    },
    Down(scope) {
      getUserRechargesPdfAddress(scope.id).then(res => {
        if (res.code == 200) {
          window.open(res.data, '_blank');

        } else {
          this.$message.error(res.msg);
        }

      })
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 12px;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 60px;
  height: 60px;
}

.das_top_item .item_title {
  font-size: 16px;
  color: #022955;
  margin: 9px 0 9px;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 10px;
}

.das_top_item .item_lab {
  display: block;
  margin-bottom: 8px;
  font-family: 'Arial';
  font-size: 18px;
  color: #1A2332;
  line-height: 34px;
  text-align: center;
  font-style: normal;
}

.item_txt {
  text-align: center;
  font-family: 'Arial Bold';
  font-weight: normal;
  font-size: 30px;
  color: #1290C9;
  line-height: 34px;
  text-align: center;
  font-style: normal;
}

.cont_m {
  margin-top: 26px;
  margin-bottom: 70px;
}

.country_box {
  margin-top: 54px;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 18px;
}

.title_txt {
  font-size: 14px;
  font-family: 'Arial Bold';
}

.title_txt img {
  width: 18px;
  margin-right: 7px;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 9px 18px;
  background: #1290c9;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 18px;
}

.btn_blue img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 10px;
  font-size: 16px;
}

.das_top_item {
  width: 33.3%;
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
}

.das_top_itempadding {
  margin: 0 14px;
}

.das_top_item .item_img {
  width: 60px;
  height: 60px;
  line-height: 70px;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_img .icon {
  width: 60px;
  height: 60px;
}

.das_top_item .item_title {
  font-size: 16px;
  color: #022955;
  margin: 9px 0 9px;
  text-align: center;
}

.top_tab {
  margin-top: 35px;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}



/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'Arial Bold';
}

.last-colmun {
  padding: 24px 0;
  border-bottom: 1px solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -26px;
  right: 0;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 26px !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 18px;
  color: #8c939d;
  width: 62px;
  height: 62px;
  line-height: 62px;
  text-align: center;
}

/deep/ .avatar {
  width: 62px;
  height: 62px;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 3px;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 16px;
  margin-left: -5px;
  color: #1a2332;
  /* float: left; */
  line-height: 34px;
  position: relative;
  left: 47%;
}

.bill_record_top_cont {
  margin-bottom: 10px;
}

.accountright_cont_box {
  padding: 30px 40px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.account_input .accountright_cont_box .history_box-head.flex_center_between_box {
  margin-bottom: 14px;
  font-family: 'Arial Bold';
  font-weight: normal;
  font-size: 24px;
  color: #1A2332;
  line-height: 34px;
  text-align: left;
  font-style: normal;
}

.account_input .sel_box {
  width: 335px;
  height: 40px;
  margin-right: 10px;
  background: #FFFFFF;
  border-radius: 10px;
}

.account_input .sel_box .el-input {
  height: 40px;
}

.br_filter_second ::v-deep .el-input__inner {
  padding-left: 10px;
  padding-right: 40px;
  font-family: 'Arial';
  font-size: 16px;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  border: 1px solid #CCCCCC;
}

.br_filter_second ::v-deep .el-input__clear {
  font-size: 16px;
  margin-right: 8px;
}

.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 335px;
  height: 40px;
}

.account_input .sel_box ::v-deep .el-date-editor {
  justify-content: flex-end;
}

.account_input .sel_box ::v-deep .el-date-editor .el-range-input {
  font-family: 'Arial';
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  font-style: normal;
}

.account_input .sel_box ::v-deep .el-input .el-icon-search:before {
  font-size: 16px;
  margin-right: 16px;
}

.br_filter_button {
  width: 100px;
  height: 40px;
  padding: 10px 20px !important;
  background: #1290C9;
  border-radius: 10px !important;
  font-family: 'Arial';
  font-size: 18px !important;
  color: #FFFFFF;
  line-height: 34px;
  text-align: center;
  font-style: normal;
}

.account_input .accountright_cont_box .flex_center_between_box {
  margin-bottom: 16px;
}

.br_table ::v-deep {
  overflow-y: auto;
  border: none;
  border-collapse: collapse;
}

.br_table ::v-deep thead,
.br_table ::v-deep .el-table__cell {
  min-height: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.br_table ::v-deep td,
.br_table ::v-deep td.el-table__cell {
  min-height: 60px !important;
  height: 60px !important;
}

.br_table ::v-deep .el-table__body-wrapper .el-table__row td:last-child,
.br_table ::v-deep .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.br_table::after {
  display: none !important;
}

.br_table.el-table {
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}

.br_table ::v-deep .el-table__cell:first-child>.cell {
  padding-left: 20px !important;
}

.br_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
  padding-right: 20px !important;
}

.br_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
  text-align: center;
  padding-right: 20px !important;
}

.br_table.el-table ::v-deep th.el-table__cell>.cell {
  font-family: 'Arial bold';
}

.br_table.el-table ::v-deep .cell,
.br_table.el-table ::v-deep .cell .table-content {
  font-size: 18px !important;
  line-height: 24px;
  color: #1A2332;
  font-family: 'Arial';
  text-align: left;
  font-style: normal;
}

.br_table.el-table ::v-deep .cell .company_link {
  color: #1290C9;
  text-decoration-line: underline;
}

.br_table ::v-deep .icon {
  width: 28px;
  height: 28px;
}

.accountright_cont_box {
  min-height: calc(100vh - 236px);
}

@media screen and (max-width: 1920px) {
  .das_top_item .item_img img {
    width: 45px;
    height: 45px;
  }

  .das_top_item .item_title {
    font-size: 14px;
    margin: 7px 0 7px;
  }

  .das_top_item .item_group {
    margin-left: 7px;
  }

  .das_top_item .item_lab {
    margin-bottom: 6px;
    font-size: 16px;
    line-height: 26px;
  }

  .item_txt {
    font-size: 20px;
    line-height: 26px;
  }

  .cont_m {
    margin-top: 20px;
    margin-bottom: 52px;
  }

  .country_box {
    margin-top: 40px;
  }

  .title {
    margin-bottom: 14px;
  }

  .title_txt {
    font-size: 12px;
  }

  .title_txt img {
    width: 14px;
    margin-right: 5px;
  }

  .btn_blue {
    padding: 7px 14px;
    font-size: 14px;
  }

  .btn_blu {
    margin-right: 14px;
  }

  .btn_blue img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .sel_box /deep/ .el-input__inner {
    border-radius: 7px;
    font-size: 14px;
  }

  .das_top_item {
    padding: 22px 0;
  }

  .das_top_itempadding {
    margin: 0 10px;
  }

  .das_top_item .item_img {
    width: 45px;
    height: 45px;
    line-height: 52px;
  }

  .das_top_item .item_img .icon {
    width: 45px;
    height: 45px;
  }

  .das_top_item .item_title {
    font-size: 14px;
    margin: 7px 0 7px;
  }

  .top_tab {
    margin-top: 26px;
  }

  .last-colmun {
    padding: 18px 0;
  }

  .dingwei {
    top: -20px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 20px !important;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 16px;
    width: 46px;
    height: 46px;
    line-height: 46px;
  }

  ::v-deep .avatar {
    width: 46px;
    height: 46px;
  }

  .el-date-editor /deep/ .el-range__icon {
    font-size: 14px;
    margin-left: -4px;
    line-height: 26px;
  }

  .bill_record_top_cont {
    margin-bottom: 7px;
  }

  .accountright_cont_box {
    padding: 22px 30px;
  }

  .account_input .accountright_cont_box .history_box-head.flex_center_between_box {
    margin-bottom: 10px;
    font-size: 20px;
    line-height: 26px;
  }

  .account_input .sel_box {
    width: 252px;
    height: 32px;
    margin-right: 7px;
    border-radius: 7px;
  }

  .account_input .sel_box .el-input {
    height: 32px;
  }

  .br_filter_second ::v-deep .el-input__inner {
    padding-left: 7px;
    padding-right: 35px;
    font-size: 14px;
    line-height: 16px;
  }

  .br_filter_second ::v-deep .el-input__clear {
    font-size: 14px;
    margin-right: 6px;
  }

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 252px;
    height: 32px;
  }

  .account_input .sel_box ::v-deep .el-date-editor .el-range-input {
    font-size: 14px;
    line-height: 16px;
  }

  .account_input .sel_box ::v-deep .el-input .el-icon-search:before {
    font-size: 14px;
    margin-right: 12px;
  }

  .br_filter_button {
    width: 75px;
    height: 30px;
    padding: 7px 15px !important;
    border-radius: 7px !important;
    font-size: 16px !important;
    line-height: 26px;
  }

  .account_input .accountright_cont_box .flex_center_between_box {
    margin-bottom: 12px;
  }

  .br_table ::v-deep thead,
  .br_table ::v-deep .el-table__cell {
    min-height: 44px !important;
    height: 44px !important;
  }

  .br_table ::v-deep td,
  .br_table ::v-deep td.el-table__cell {
    min-height: 50px !important;
    height: 50px !important;
  }

  .br_table ::v-deep .el-table__cell:first-child>.cell {
    padding-left: 15px !important;
  }

  .br_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
    padding-right: 15px !important;
  }

  .br_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
    padding-right: 15px !important;
  }

  .br_table.el-table ::v-deep .cell,
  .br_table.el-table ::v-deep .cell .table-content {
    font-size: 16px !important;
    line-height: 18px;
  }

  .br_table ::v-deep .icon {
    width: 22px;
    height: 22px;
  }
}

@media screen and (max-width: 1439px) {
  .das_top_item .item_img img {
    width: 40px;
    height: 40px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 6px 0 6px;
  }

  .das_top_item .item_group {
    margin-left: 6px;
  }

  .das_top_item .item_lab {
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 22px;
  }

  .item_txt {
    font-size: 20px;
    line-height: 22px;
  }

  .cont_m {
    margin-top: 18px;
    margin-bottom: 46px;
  }

  .country_box {
    margin-top: 36px;
  }

  .title {
    margin-bottom: 12px;
  }

  .title_txt {
    font-size: 12px;
  }

  .title_txt img {
    width: 12px;
    margin-right: 5px;
  }

  .btn_blue {
    padding: 6px 12px;
    font-size: 12px;
  }

  .btn_blu {
    margin-right: 12px;
  }

  .btn_blue img {
    width: 10px;
    height: 10px;
    margin-right: 4px;
  }

  .sel_box /deep/ .el-input__inner {
    border-radius: 7px;
    font-size: 12px;
  }

  .das_top_item {
    padding: 20px 0;
  }

  .das_top_itempadding {
    margin: 0 9px;
  }

  .das_top_item .item_img {
    width: 40px;
    height: 40px;
    line-height: 46px;
  }

  .das_top_item .item_img .icon {
    width: 40px;
    height: 40px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 6px 0 6px;
  }

  .top_tab {
    margin-top: 24px;
  }

  .last-colmun {
    padding: 16px 0;
  }

  .dingwei {
    top: -18px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 18px !important;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 14px;
    width: 42px;
    height: 42px;
    line-height: 42px;
  }

  ::v-deep .avatar {
    width: 42px;
    height: 42px;
  }

  .el-date-editor /deep/ .el-range__icon {
    font-size: 12px;
    margin-left: -3px;
    line-height: 22px;
  }

  .bill_record_top_cont {
    margin-bottom: 6px;
  }

  .accountright_cont_box {
    padding: 20px 26px;
  }

  .account_input .accountright_cont_box .history_box-head.flex_center_between_box {
    margin-bottom: 9px;
    font-size: 16px;
    line-height: 22px;
  }

  .account_input .sel_box {
    width: 256px;
    height: 26px;
    min-width: 256px;
    margin-right: 6px;
    border-radius: 6px;
  }

  .account_input .sel_box .el-input {
    height: 26px;
  }

  .br_filter_second ::v-deep .el-input__inner {
    padding-left: 6px;
    padding-right: 30px;
    font-size: 14px;
    line-height: 16px;
  }

  .br_filter_second ::v-deep .el-input__clear {
    font-size: 14px;
    margin-right: 5px;
  }

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 256px;
    height: 26px;
    min-width: 256px;
  }

  .account_input .sel_box ::v-deep .el-date-editor .el-range-input {
    font-size: 14px;
    line-height: 16px;
  }

  .account_input .sel_box ::v-deep .el-input .el-icon-search:before {
    font-size: 12px;
    margin-right: 10px;
  }

  .br_filter_button {
    width: 68px;
    height: 26px;
    padding: 6px 12px !important;
    border-radius: 6px !important;
    font-size: 14px !important;
    line-height: 22px;
  }

  .account_input .accountright_cont_box .flex_center_between_box {
    margin-bottom: 10px;
  }

  .br_table ::v-deep thead,
  .br_table ::v-deep .el-table__cell {
    min-height: 32px !important;
    height: 32px !important;
  }

  .br_table ::v-deep td,
  .br_table ::v-deep td.el-table__cell {
    min-height: 40px !important;
    height: 40px !important;
  }

  .br_table ::v-deep .el-table__cell:first-child>.cell {
    padding-left: 12px !important;
  }

  .br_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
    padding-right: 12px !important;
  }

  .br_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
    padding-right: 12px !important;
  }

  .br_table.el-table ::v-deep .cell,
  .br_table.el-table ::v-deep .cell .table-content {
    font-size: 14px !important;
    line-height: 16px;
  }

  .br_table ::v-deep .icon {
    width: 18px;
    height: 18px;
  }

  .accountright_cont_box {
    min-height: calc(100vh - 212px);
  }
}
</style>
